export default __webpack_public_path__ + "static/media/image-2.b9b826bc.png";